import { useState } from "react";

import { ULThemeButton } from "@/components/ULThemeButton";

export interface ULThemeRecoveryCodeProps {
  code: string;
  label: string;
  copyLabel: string;
  copiedLabel: string;
  onCopied?: () => void;
}

/** Shown once and never again, so the code stays selectable when the clipboard is denied. */
function ULThemeRecoveryCode({
  code,
  label,
  copyLabel,
  copiedLabel,
  onCopied,
}: ULThemeRecoveryCodeProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    void navigator.clipboard?.writeText(code).then(
      () => {
        setCopied(true);
        onCopied?.();
      },
      () => setCopied(false)
    );
  };

  return (
    <div className="mb-6">
      <span className="k-eyebrow">{label}</span>
      <div className="mt-2 flex items-center justify-between gap-3 rounded-(--radius-input) border border-widget-border p-3">
        <code className="font-mono text-(length:--ul-theme-font-body-text-size) break-all select-all">
          {code}
        </code>
        <ULThemeButton onClick={handleCopy} variant="link" size="link">
          {copied ? copiedLabel : copyLabel}
        </ULThemeButton>
      </div>
    </div>
  );
}

export default ULThemeRecoveryCode;
